<script lang="ts">
    import {navigateTo, routeIsActive} from "svelte-router-spa";

    export let to:string = '';
    export let currentRoute = {};

    let classApplication:string = 'text-gray-500';
    $: if (currentRoute && to && routeIsActive(to, false)) {
        classApplication = 'text-blue-600 bg-gray-200 bg-opacity-40 sm:!bg-opacity-100';
    } else {
        classApplication = 'text-white sm:!text-gray-500';
    }
</script>

<button on:click={() => navigateTo(to)} class="flex cursor-pointer items-center gap-2 text-sm py-2 md:!py-4 px-2 md:!px-4 hover:bg-gray-100 {classApplication}">
    <slot name="icon">Icon</slot>
    <slot></slot>
</button>